import { createRoute } from "@tanstack/react-router"
import type { ReactNode } from "react"
import { AccessWizardScreen } from "../../screens/developers/access-wizard-screen"
import { DevelopersScreen } from "../../screens/developers/developers-screen"
import { RequestsScreen } from "../../screens/developers/requests-screen"
import { WebhooksScreen } from "../../screens/developers/webhooks-screen"
import { CABINET_PATHS } from "../../shell/nav-items"
import { protectedRoute } from "./protected-route"
import { SectionGuard } from "./section-guard"

/**
 * «Разработчикам» (4-В6/В7/В8, ПА-6). Раздел — по праву api_keys.manage (как у пункта меню);
 * уведомления о событиях — своим правом webhooks.manage, ровно тем, что требует сервер.
 * Отдельный файл — по той же причине, что directory-routes: общий список маршрутов правят
 * несколько агентов сразу.
 */
export const developersRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: CABINET_PATHS.developers,
  component: function DevelopersRouteComponent(): ReactNode {
    const navigate = developersRoute.useNavigate()
    return (
      <SectionGuard id="developers">
        <DevelopersScreen
          onGrant={(id) => {
            void navigate({ to: "/developers/$integrationId/access", params: { integrationId: id } })
          }}
          onWebhooks={(id) => {
            void navigate({ to: "/developers/$integrationId/webhooks", params: { integrationId: id } })
          }}
          onRequests={(id) => {
            void navigate({ to: "/developers/$integrationId/requests", params: { integrationId: id } })
          }}
        />
      </SectionGuard>
    )
  },
})

export const developerAccessRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: "/developers/$integrationId/access",
  component: function DeveloperAccessRouteComponent(): ReactNode {
    const { integrationId } = developerAccessRoute.useParams()
    const navigate = developerAccessRoute.useNavigate()
    const back = (): void => {
      void navigate({ to: CABINET_PATHS.developers })
    }
    return (
      <SectionGuard id="developers">
        <AccessWizardScreen integrationId={integrationId} onBack={back} onDone={back} />
      </SectionGuard>
    )
  },
})

export const developerWebhooksRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: "/developers/$integrationId/webhooks",
  component: function DeveloperWebhooksRouteComponent(): ReactNode {
    const { integrationId } = developerWebhooksRoute.useParams()
    const navigate = developerWebhooksRoute.useNavigate()
    return (
      <SectionGuard id="developers" permission="webhooks.manage">
        <WebhooksScreen
          integrationId={integrationId}
          onBack={() => {
            void navigate({ to: CABINET_PATHS.developers })
          }}
        />
      </SectionGuard>
    )
  },
})

export const developerRequestsRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: "/developers/$integrationId/requests",
  component: function DeveloperRequestsRouteComponent(): ReactNode {
    const { integrationId } = developerRequestsRoute.useParams()
    const navigate = developerRequestsRoute.useNavigate()
    return (
      <SectionGuard id="developers">
        <RequestsScreen
          integrationId={integrationId}
          onBack={() => {
            void navigate({ to: CABINET_PATHS.developers })
          }}
        />
      </SectionGuard>
    )
  },
})

export const developerRoutes = [developersRoute, developerAccessRoute, developerWebhooksRoute, developerRequestsRoute]
